import { api } from './api';

export const fetchPromoCodes = (params, options) => {
  return api.get('/pricing/promo_code', params, options);
};

export const fetchPromoCodeById = (id) => {
  return api.get(`/pricing/promo_code/${id}`);
};

export const createPromoCode = (payload) => {
  return api.post('/pricing/promo_code', payload);
};

export const deletePromoCode = (id) => {
  return api.delete(`/pricing/promo_code/${id}`);
};

export const updatePromoCode = (id, payload) => {
  return api.put(`/pricing/promo_code/${id}`, payload);
};
